/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import get from 'lodash/get';
import { createSelector } from 'reselect';

import * as types from '../constants/ActionTypes';

import { getTenant } from './tenantReducer';

export const getDocURL = state => get(state, 'currentUser.userData.docURL');
/**
 * Are we in a MAS environment?
 */
export const isICP = state => get(state, 'currentUser.userData.isICP');

export const userReducer = (
  state = {
    error: null,
    isLoading: true,
    relatedTenants: {
      data: [],
      error: null,
      isLoading: null,
    },
    userData: null,
  },
  action
) => {
  switch (action.type) {
    case types.GET_CURRENT_USER_REQUEST:
      return { ...state, error: null, isLoading: true };
    case types.GET_CURRENT_USER_SUCCESS:
      return { ...state, error: null, isLoading: false, userData: action.data };
    case types.GET_CURRENT_USER_FAILURE:
      return { ...state, error: action.error, isLoading: false, userData: null };

    case types.GET_CURRENT_USER_RESOURCES_REQUEST:
      return { ...state, error: null, isLoading: true };
    case types.GET_CURRENT_USER_RESOURCES_SUCCESS:
      return { ...state, error: null, isLoading: false, userResources: action.data };
    case types.GET_CURRENT_USER_RESOURCES_FAILURE:
      return { ...state, error: action.error, isLoading: false, userResources: null };

    case types.LOGOUT_CURRENT_USER_REQUEST:
      return { ...state, isLoading: true };
    case types.LOGOUT_CURRENT_USER_SUCCESS:
    case types.LOGOUT_CURRENT_USER_FAILURE:
      return { ...state, error: action.error, isLoading: false, userData: null };

    case types.GET_TENANTS_RELATED_TO_USER_REQUEST:
      return {
        ...state,
        relatedTenants: {
          data: [],
          error: null,
          isLoading: true,
        },
      };
    case types.GET_TENANTS_RELATED_TO_USER_SUCCESS:
      return {
        ...state,
        relatedTenants: {
          data: action.data,
          error: null,
          isLoading: false,
        },
      };
    case types.GET_TENANTS_RELATED_TO_USER_FAILURE:
      return {
        ...state,
        relatedTenants: {
          data: [],
          error: action.error,
          isLoading: false,
        },
      };

    default:
      return state;
  }
};

// Selectors
export const getCurrentUser = state => get(state, 'currentUser.userData') || {};
export const getCurrentUserResources = state => get(state, 'currentUser.userResources') || {};
export const getCurrentUserEmailId = state => get(state, 'currentUser.userData.id') || {};
export const getCurrentUserAccessControls = state =>
  get(state, 'currentUser.userData.accessControls') || [];

// secondary tenants
const getRelatedTenants = state => get(state, 'currentUser.relatedTenants.data');

// memoized tenant selector that filters out the current tenant
export const getOtherTenants = createSelector(
  [getRelatedTenants, getTenant],
  (relatedTenants, { tenantId }) =>
    (Array.isArray(relatedTenants) ? relatedTenants : []).filter(
      tenant => tenantId && tenant.toLowerCase() !== tenantId.toLowerCase()
    )
);
